import "./CommonFooter.css";

import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import {
  callIcon,
  locationmark,
  mailIcon,
  mailIcon2,
} from "../SvgPaths/SvgPaths";
import logo from "../../assets/images/png/whiteLogo.png";
import playStore from "../../assets/images/png/google-apple.png";
import { Link, useNavigate } from "react-router-dom";
import { addSubscriber } from "../../services/SubscribeService";
import { ToastContainer, toast } from "react-toastify";

const CommonFooter = () => {
  const [usermail, setuserMail] = useState("");
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
  const navigate = useNavigate();

  const addMail = async () => {
    const token = localStorage.getItem("token");
    const useremail = {
      email: usermail,
    };
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!usermail.trim() || !emailRegex.test(usermail)) {
      return toast.error("Please enter valid email");
    }
    const res = await addSubscriber(useremail, token);
    if (res) {
      setuserMail("");
      toast.success("Subscribed successfully");
    }
  };

  useEffect(() => {
    setCurrentYear(new Date().getFullYear());
  }, []);
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          <div className="footer-branding">
            <div className="logo-container">
              <img src={logo} alt="logo" width={100} />
            </div>
            <h3>Subscribe for Latest Offers</h3>
            <p>
              Get the latest news, new product notifications, and exclusive
              promotions conveniently in your inbox!
            </p>
            <form
              className="newsletter-form"
              onSubmit={(e) => e.preventDefault()}
            >
              <label htmlFor="footer-email" className="sr-only">
                Email address
              </label>
              <input
                placeholder="Enter Your Email Address"
                value={usermail}
                onChange={(e) => {
                  setuserMail(e.target.value);
                }}
                type="email"
              />
              <button onClick={addMail}>Subscribe</button>
            </form>
          </div>

          <div className="footer-links">
            <h3>Our Services</h3>
            <ul>
              <li>
                <Link to={"/all-product"}>Rent/Lease/Sale</Link>
              </li>
              <li>
                <Link to={"/progressive-farming-solutions"}>
                  Progressive Farming Solutions
                </Link>
              </li>
              <li>
                <Link to={"/farmer-shop"}>Farmer City Mart</Link>
              </li>
              <li>
                <Link to={"/gaon-se"}>Gaon Se</Link>
              </li>
              <li>
                <Link to="https://droneplanet.in/aboutdaas" target="_blank">
                  Drone Services
                </Link>
              </li>
              <li>
                <Link to={"/consultation"}>Consultation</Link>
              </li>
              <li>
                <Link to={"/hire-farm-labour"}>Hire Farm Labour</Link>
              </li>
            </ul>
          </div>

          <div className="footer-links">
            <h3>Information</h3>
            <ul>
              <li>
                <Link to={"/about-us"}>About Us</Link>
              </li>
              <li>
                <Link to={"/privacy-policy"}>Privacy Policy</Link>
              </li>
              <li>
                <Link to={"/delivery-policy"}>Delivery Policy</Link>
              </li>
              <li>
                <Link to={"/refund-policy"}>Refund Policy</Link>
              </li>
              <li>
                <Link to={"/faq"}>FAQ's</Link>
              </li>
              <li>
                <Link to={"/term-and-conditions"}>Terms & Condition</Link>
              </li>
            </ul>
          </div>

          <div className="footer-links contact-info">
            <h3>Contact Us</h3>
            <ul>
              <li>
                <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                  />
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                  />
                </svg>
                <Link
                  target="_blank"
                  to="https://maps.app.goo.gl/dDQgbMUNjCpYMk716"
                >
                  <span>
                    251, Phase IV, Udyog Vihar, Sector 18, Gurugram,
                    Haryana-122015
                  </span>
                </Link>
              </li>
              <li>
                <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                  />
                </svg>
                <Link to="mailto:info@farmerscity.in">
                  <span>info@farmerscity.in</span>
                </Link>
              </li>
              <li>
                <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                  ></path>
                </svg>
                <Link to="tel:+91-0987654321">
                  <span> +91-0987654321</span>
                </Link>
              </li>
            </ul>
          </div>

          {/* <Col md={6}>
                  <Link to={'/farmercity-agri-output'}>
                    <li className='d-flex align-items-start gap-3 mt-2'>
                      <p className='mb-0 text-white ff_heebo fs_xsm'>
                        Farmer's City Agri Output
                      </p>
                    </li>
                  </Link>
                  <Link to={'/livestock-nutrient'}>
                    <li className='d-flex align-items-start gap-3 mt-2'>
                      <p className='mb-0 text-white ff_heebo fs_xsm'>
                        Livestock Nutrition
                      </p>
                    </li>
                  </Link>
                  <Link to={'/booking-agri-drone'}>
                    <li className='d-flex align-items-start gap-3 mt-2'>
                      <p className='mb-0 text-white ff_heebo fs_xsm'>
                        Booking of Agri-Drone
                      </p>
                    </li>
                  </Link>
                  <Link to={'/FC-agri-input-store'}>
                    <li className='d-flex align-items-start gap-3 mt-2'>
                      <p className='mb-0 text-white ff_heebo fs_xsm'>
                        FC Agri Input Store
                      </p>
                    </li>
                  </Link>
                  <Link to={'/soil-testing-lab'}>
                    <li className='d-flex align-items-start gap-3 mt-2'>
                      <p className='mb-0 text-white ff_heebo fs_xsm'>
                        Soil Testing Lab
                      </p>
                    </li>
                  </Link>
                </Col> */}

          {/* <Col sm={6} lg={2}>
            <ul className='m-0 p-0'>
              <li className='mt-5'>
                <div
                  onClick={() => navigate('/')}
                  className='d-flex flex-column gap-2  position-relative logo cursor-pointer'
                >
                  <img width={81} src={logo} alt='logo' />
                  <p className='mb-0 fw-bold ff_roboto text-white fs_md text-nowrap'>
                    Farmer’s City
                  </p>
                </div>
              </li>
              <li>
                <div className='d-flex gap-3 mt-3 flex-column'>
                  <img className='store-logo' src={playStore} alt='playstore' />
                </div>
              </li>
            </ul>
          </Col> */}
        </div>

        <div className="footer-bottom">
          <div className="footer-copyright">
            © Copyright {currentYear}. All Rights Reserved by Farmer’s City
          </div>
        </div>
      </div>
    </footer>
  );
};

export default CommonFooter;
